var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{ref:"ChartPreview",attrs:{"chartData":_vm.datacollection,"options":_vm.options,"styles":{position: 'relative', 'margin-top': '10px'}}})}
var staticRenderFns = []

export { render, staticRenderFns }